import React from 'react';

const LoginForm = ({ username, password, onChange, onSubmit, isSubmitting = false }) => {
  return (
    <form onSubmit={onSubmit} className="w-100 login-form">
      <div className="mb-3">
        <label htmlFor="username" className="form-label">Email address</label>
        <input
          type="text"
          className="form-control"
          id="username"
          name="username"
          placeholder="you@company.com"
          value={username}
          onChange={onChange}
          autoComplete="username"
          disabled={isSubmitting}
          required
        />
      </div>

      <div className="mb-3">
        <label htmlFor="password" className="form-label">Password</label>
        <input
          type="password"
          className="form-control"
          id="password"
          name="password"
          placeholder="Enter password"
          value={password}
          onChange={onChange}
          autoComplete="current-password"
          disabled={isSubmitting}
          required
        />
      </div>

      <div className="mb-3 form-check">
        <input type="checkbox" className="form-check-input" id="rememberMe" />
        <label className="form-check-label" htmlFor="rememberMe">Remember me</label>
      </div>

      <button type="submit" className="btn w-100 login-submit" disabled={isSubmitting}>
        {isSubmitting ? (
          <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Signing in...</>
        ) : 'Sign in'}
      </button>
    </form>
  );
};

export default LoginForm;
